// extracted by mini-css-extract-plugin
module.exports = {"bannerWrap":"home_bannerWrap__u5TdY","bannerItem":"home_bannerItem__1xAYe","content":"home_content__2pc-b"};